import React from 'react';
import styled from 'styled-components';
import FormStylesOptions from '../../../constants/FormStylesOptions';

const StyledSelect = styled.select`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.backgroundColor};
  font-size: ${(props) => props.fontSize}px !important;
  color: ${(props) => props.fontColor};
  font-style: ${(props) => props.fontStyle};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};
  border-radius: ${(props) => props.borderRadius}px;
  border: ${(props) => props.border};
  padding: ${(props) => props.padding}px;
  transition: all 0.15s ease-in-out;

  text-overflow: ${(props) => props.textOverflow || 'clip'};
  ${(props) => (props.textOverflow !== FormStylesOptions.textOverflowEllipsis ? 'white-space: nowrap;' : 'white-space: normal;')}
  ${(props) => (props.textOverflow !== FormStylesOptions.textOverflowEllipsis ? 'overflow: hidden;' : 'overflow: visible;')}

  &:focus, &:focus-visible {
    outline: unset;
    border: ${(props) => props.borderWidth}px solid ${(props) => props.primaryColor};
  }

  &:hover {
    cursor: pointer;
    ${(props) => (props.disabled ? '' : `border: ${props.borderWidth}px solid ${props.primaryColor}`)};
  }

`;

/**
 * This components main purpose is to isolate the input
 * styles into one location and not require style updates
 * all over the place when we update it in the future.
 */
const FieldGenericSelect = (props) => {

  const { borderWidth, borderColor, options } = props;

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  const optionNodes = [];
  if (options && options.length > 0) {
    options.forEach((option) => {
      if (option.deleted) return;
      optionNodes.push(
        <option key={option._id} value={option._id}>
          {option.value}
        </option>
      );
    });
  }

  return (
    <StyledSelect {...props} border={border}>
      <option value="" />
      {optionNodes}
    </StyledSelect>
  );

};

export default React.memo(FieldGenericSelect);
